import isUndefinedOrNull from '../../TypeHelpers/isUndefinedOrNull';
import convertToT from "./convertToT";
export default function read(storage, key) {
    const value = storage.getItem(key);
    return isUndefinedOrNull(value) ? undefined : convertToT(value);
}
